
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/icons",
      function () {
        return require("private-next-pages/material-ui/icons.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/icons"])
      });
    }
  